// extracted by mini-css-extract-plugin
export default {"touchIconButton":"BookUniViniTouch_touchIconButton__O-c34","touchAudioPlayer":"BookUniViniTouch_touchAudioPlayer__IgZKM"};